import type { VoidFunctionComponent } from 'react';

import { useDebouncedInputValue } from '../../../hooks';
import { SearchInput } from '../../generic';

import styles from './VendoredDependencies.module.less';

const VendoredDependenciesContainer: VoidFunctionComponent = () => {
  //  TODO: Later this will actually be used
  const { value, onChange } = useDebouncedInputValue();

  return (
    <>
      <header className={styles.header}>
        <h1 className={styles.title}>
          Vendored Dependencies
        </h1>
        {/* TODO: Include the count of vendored deps + the selected/active path */}
      </header>
      <div>
        <span className={styles.search}>
          <SearchInput
            label="vendored-dependencies-filter-search"
            placeholder="Search dependencies"
            size="small"
            value={value}
            onChange={onChange}
          />
        </span>
        {/* TODO: later if we add more filters or the compare button, it will go here */}
      </div>
    </>
  );
};

export default VendoredDependenciesContainer;
